import React from "react";

const MapSection = () => {
  return (
    <section className="wpo-contact-map-section" style={{marginTop:"150px"}}>
      <h2 className="hidden">Contact map</h2>
      <div className="wpo-contact-map">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3226.198801773758!2d-79.80067678473132!3d36.03985378011219!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x885319a657529489%3A0x4da4329190935053!2sMeridian+Convention+%26+Event+Center!5e0!3m2!1sen!2sin!4v1459342564482"
          allowFullScreen
          title="Google Maps Location"
        ></iframe>
      </div>
    </section>
  );
};

export default MapSection;
